"use strict";

exports.__esModule = true;
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

exports.default = guard;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/polished/lib/internalHelpers/_guard.js
// module id = 17
// module chunks = 0